module.exports = __webpack_public_path__ + "static/media/delete button.57e4ff65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/delete button.svg
// module id = 878
// module chunks = 0